import type { ConfirmOptions } from "@/components/ui/confirm-dialog";
import type { Order, OrderStatus } from "@/redux/services/order/order.type";

/** Statuses that end an order for good: they always ask for confirmation. */
const CLOSING_STATUSES: OrderStatus[] = ["canceled", "rejected"];

export const isClosingStatus = (status: OrderStatus): boolean =>
  CLOSING_STATUSES.includes(status);

export type OrderConfirmLabelSource = Partial<
  Pick<Order, "dailySequence" | "orderNumber">
>;

/** Same label the KDS card and the receipt show: daily sequence, else order number. */
export const getOrderConfirmLabel = (order: OrderConfirmLabelSource): string =>
  order.dailySequence != null
    ? String(order.dailySequence)
    : (order.orderNumber ?? "");

/**
 * Wording of the confirmation shown before canceling or rejecting an order
 * (SFRESTO-148 / SFRESTO-84). The icon is added by `useOrderCloseConfirm`.
 */
export const getOrderCloseConfirmOptions = (
  order: OrderConfirmLabelSource,
  status: OrderStatus
): Omit<ConfirmOptions, "icon"> => {
  const label = getOrderConfirmLabel(order);
  if (status === "rejected") {
    return {
      title: `Rejeter la commande #${label} ?`,
      description:
        "Cette action est irréversible. Pensez à prévenir le client.",
      confirmText: "Rejeter la commande",
      cancelText: "Retour",
      variant: "destructive",
    };
  }
  return {
    title: `Annuler la commande #${label} ?`,
    description:
      "Cette action est irréversible. Pensez à prévenir le serveur ou le client.",
    confirmText: "Annuler la commande",
    cancelText: "Retour",
    variant: "destructive",
  };
};
